import ReactMarkdownParent from 'react-markdown';
import { colors, gap, Grid, spacing, typography } from '@lamimed/pantheon';
import styled from 'styled-components';

// This variable is needed for a UI detail because `spacing.medium` don't align properly
// with the text above, we observed a little gap between the bullets and the text, so this 0.5rem is to correct.
const spaceToAlignWithText = '0.5rem';

export const ReactMarkdown = styled(ReactMarkdownParent)`
  text-align: left;

  ${typography.body_text_1};
  color: ${colors.text__primary};

  ul {
    max-width: 100%;
    list-style-image: url('/images/list-bullets.svg');
    margin-top: ${spacing.medium};

    li {
      padding-left: ${spacing.medium};
      color: ${colors.text__primary};
      margin-top: ${spacing.small};
      margin-left: calc(${spacing.medium} + ${spaceToAlignWithText});
    }
  }
`;

export const ImageContainer = styled.div`
  margin: ${spacing.medium} 0 0 0;
  ${gap(spacing.small)};
  display: flex;
  flex-direction: column;
`;

export const TextContainer = styled(Grid.Wrapper)`
  display: flex;
  flex-direction: column;
`;
